import { render } from "./LegendLoading.vue?vue&type=template&id=0dd8a956&scoped=true"
import script from "./LegendLoading.vue?vue&type=script&lang=js"
export * from "./LegendLoading.vue?vue&type=script&lang=js"

import "./LegendLoading.vue?vue&type=style&index=0&id=0dd8a956&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd8a956"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
